<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-12 16:02:19
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-30 15:40:40
 * @FilePath: \hzs-nutra-wecom-shop\src\views\myTeam\operateMember.vue
 * @Description: 我的团队 - 操作成员(新增、编辑、离职、恢复在职)
-->

<template>
  <div class="page-container">
    <div class="mainContent">
      <van-form
        ref="formRef"
        label-width="auto"
        label-align="right"
        @submit="onSubmit"
      >
        <!-- 手机号码 -->
        <van-field
          v-model="formData.phone"
          name="phone"
          type="tel"
          placeholder="请输入11位手机号"
          maxlength="11"
          input-align="right"
          :rules="[
            { required: true, message: '请填写手机号' },
            { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确' },
          ]"
          @update:model-value="onPhoneInput($event)"
        >
          <template #label>
            <span class="required-mark">*</span>注册手机号码
          </template>
        </van-field>

        <!-- 姓名 -->
        <van-field
          v-model="formData.name"
          name="name"
          placeholder=""
          input-align="right"
          :rules="[{ required: true, message: '请填写姓名' }]"
        >
          <template #label> <span class="required-mark">*</span>姓名 </template>
        </van-field>

        <!-- 组织、岗位 -->
        <van-cell-group
          v-for="(item, index) in formData.shop_clerk_position"
          :key="item.id"
          title=""
        >
          <van-cell center :border="false">
            <template #title>
              <div class="cell-group-custom-header">
                <div class="cell-group-custom-title">就职组织</div>
              </div>
            </template>
            <template #right-icon>
              <div class="flex align-center">
                <van-icon
                  v-if="formData.shop_clerk_position.length > 0"
                  size="21px"
                  color="#FF0000"
                  name="delete"
                  class="mr-10"
                  @click="handleStateDel(index)"
                />

                <van-icon
                  name="add"
                  size="21px"
                  color="#DCBB89"
                  @click="handleStateAdd"
                />
              </div>
            </template>
          </van-cell>

          <div class="cell-group-custom-content">
            <van-field
              v-model="item.departmentName"
              readonly
              name="departmentName"
              placeholder="请选择"
              input-align="right"
              :rules="[{ required: true, message: '请选择组织' }]"
              @click="handleDepartmentPicker(index)"
            >
              <template #label>
                <span class="required-mark">*</span>组织
              </template>
            </van-field>

            <van-field
              v-model="item.positionName"
              readonly
              name="positionName"
              placeholder="请选择"
              input-align="right"
              :rules="[{ required: true, message: '请选择岗位' }]"
              @click="handlePositionPicker(index, item.type as never as number)"
            >
              <template #label>
                <span class="required-mark">*</span>岗位
              </template>
            </van-field>
          </div>
        </van-cell-group>

        <!-- 主播 -->
        <van-cell v-if="!id" center :border="false">
          <template #value>
            <div class="flex align-center justify-sb">
              <!-- 1. 左侧：固定标题 "主播" -->
              <div class="left-label">主播</div>

              <!-- 2. 右侧：包含描述文字和开关 -->
              <div class="right-content flex align-center">
                <span class="desc-text">支持在手机端直播</span>

                <!-- 开关控件 -->
                <van-switch
                  v-model="formData.is_anchor"
                  size="28px"
                  active-color="#DCBB89"
                >
                </van-switch>
              </div>
            </div>
          </template>
        </van-cell>

        <!-- 在职状态 -->
        <van-cell
          v-if="id && status == 2"
          center
          :border="false"
          title="在职状态"
        >
          <van-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="2"
            active-color="#DCBB89"
            size="28px"
          />
        </van-cell>
      </van-form>

      <!-- 底部保存按钮 -->
      <div
        class="bottom_button_box justify-se"
        :class="id && status == 2 ? 'justify-se' : ''"
      >
        <van-button
          v-if="id && status != 2"
          round
          block
          plain
          type="primary"
          color="#DCBB89"
          class="save-btn"
          @click="removeMember"
        >
          离职解绑
        </van-button>

        <van-button
          v-if="status != 2"
          round
          block
          type="primary"
          color="#DCBB89"
          class="save-btn"
          @click="onSubmit"
        >
          确认
        </van-button>

        <van-button
          v-if="id && status == 2"
          round
          block
          type="primary"
          color="#FF0000"
          class="save-btn pct50"
          @click="resetMember"
        >
          岗位恢复
        </van-button>
      </div>
    </div>

    <van-popup v-model:show="showPositionPicker" round position="bottom">
      <van-picker
        :columns="positionsOptions"
        @cancel="showPositionPicker = false"
        @confirm="onPositionConfirm"
      />
    </van-popup>

    <van-popup v-model:show="showDepartmentPicker" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="departmentList"
        :field-names="customFieldName"
        @close="showDepartmentPicker = false"
        @change="onDepartmentConfirm"
        @finish="showDepartmentPicker = false"
      />

      <div class="sureBtn">
        <van-button
          type="primary"
          block
          round
          class="sureBtn"
          @click="showDepartmentPicker = false"
        >
          确认选择
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import MyTeamApi from "@/utils/api/myTeam";
import authApi from "@/utils/api/auth";

import { nanoid } from "nanoid";
import { showFailToast, showSuccessToast, showConfirmDialog } from "vant";

// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
const { id, status, phone } = route.query;
const formRef = ref();
// 表单数据
const formData = ref({
  name: undefined,
  phone: undefined,
  shop_clerk_position: [
    {
      positionName: undefined,
      position_uuid: undefined,
      departmentName: undefined,
      department_uuid: undefined,
      type: undefined,
      id: nanoid(),
    },
  ],
  is_anchor: undefined,
  status: undefined,
});

let shop_clerk_uuid: string | undefined | null = undefined;
const positionList = ref([]);
const departmentList = ref([]);
const showPositionPicker = ref(false);
const showDepartmentPicker = ref(false);
const currentPositionIndex = ref(0);
const currentDepartmentIndex = ref(0);
const currentDptType = ref(0);

const positionsOptions = computed(() => {
  let res = JSON.parse(JSON.stringify(positionList.value));
  if (currentDptType.value == 2) {
    res = res.filter((v) => v.text == "店员" || v.text == "店长");
  }

  return res;
});

const cascaderValue = ref("");

const customFieldName = {
  text: "name",
  value: "uuid",
  children: "children",
};
// --------------------------------------- 方法、事件
onMounted(async () => {
  shop_clerk_uuid =
    (id as string) || (localStorage.getItem("shop_clerk_uuid") as string);

  GroupService.getDepartmentTree();
  GroupService.getPosition();

  // 获取用户信息
  if (!phone) return;
  const res = await GroupService.getNameByPhone(phone);
  let temp = {
    name: undefined,
    phone: undefined,
    shop_clerk_position: [
      {
        positionName: undefined,
        position_uuid: undefined,
        departmentName: undefined,
        department_uuid: undefined,
        type: undefined,
        id: nanoid(),
      },
    ],
    is_anchor: undefined,
    status: undefined,
  };
  if (res?.data) {
    temp = res?.data;
  }
  let res2 = await authApi.myDepartments({
    shop_clerk_uuid,
    shop_clerk_uuid_not_required: false,
  });
  if (res2?.data) {
    let _shop_clerk_position_ = (res2?.data || []).map((v) => ({
      positionName: v.position.name,
      position_uuid: v.position.uuid,
      departmentName: v.department.name,
      department_uuid: v.department.uuid,
      type: v?.department?.type,
      id: nanoid(),
    }));
    temp.shop_clerk_position = _shop_clerk_position_;
  }
  formData.value = temp;
});

// --------- 选择岗位
function handlePositionPicker(index: number, _type: number) {
  currentDptType.value = _type;
  showPositionPicker.value = true;
  currentPositionIndex.value = index;
}
// 确认 选择当前岗位
const onPositionConfirm = ({ selectedOptions }) => {
  //   console.log(selectedOptions);
  //   console.log(currentPositionIndex.value);

  formData.value.shop_clerk_position[currentPositionIndex.value].positionName =
    selectedOptions[0].text;
  formData.value.shop_clerk_position[currentPositionIndex.value].position_uuid =
    selectedOptions[0].value;
  showPositionPicker.value = false;
};
// --------- 选择部门
function handleDepartmentPicker(index) {
  showDepartmentPicker.value = true;
  currentDepartmentIndex.value = index;
}
// 确认 选择当前岗位
const onDepartmentConfirm = ({ value, selectedOptions, tabIndex }) => {
  //   console.log(value);
  //   console.log(selectedOptions);
  //   console.log(tabIndex);

  formData.value.shop_clerk_position[
    currentDepartmentIndex.value
  ].departmentName = selectedOptions[selectedOptions.length - 1].name;
  formData.value.shop_clerk_position[
    currentDepartmentIndex.value
  ].department_uuid = selectedOptions[selectedOptions.length - 1].uuid;
  formData.value.shop_clerk_position[currentDepartmentIndex.value].type =
    selectedOptions[selectedOptions.length - 1].type;
};

let timer = null; // 定时器引用
// 根据手机号 获取 姓名
function onPhoneInput(value) {
  if (!value) return;

  // 1. 基础校验：长度必须是 11 位
  if (value.length !== 11) {
    if (timer) clearTimeout(timer);
    return;
  }

  // 2. 格式校验：必须符合正则
  const phoneRegex = /^1[3-9]\d{9}$/;
  if (!phoneRegex.test(value)) {
    if (timer) clearTimeout(timer);
    return;
  }

  // 3. 防抖处理：用户停止输入 500ms 后再请求
  if (timer) clearTimeout(timer);
  timer = setTimeout(async () => {
    try {
      // 这里调用你的真实接口
      const res = await GroupService.getNameByPhone(value);
      if (res?.code === 200) {
        formData.value.name = res?.data?.name;
      }
    } catch (error) {
      console.error(error);
      showFailToast("获取失败，请检查手机号");
    }
  }, 500); // 500毫秒延迟
}

// 添加 岗位+组织
function handleStateAdd() {
  formData.value.shop_clerk_position.push({
    positionName: undefined,
    position_uuid: undefined,
    departmentName: undefined,
    department_uuid: undefined,
    id: nanoid(),
  });
}
// 删除 岗位+组织
function handleStateDel(index) {
  formData.value.shop_clerk_position.splice(index, 1);
}

// 离职绑定
function removeMember() {
  showConfirmDialog({
    title: "提示",
    message: "是否确认解绑成员：" + formData.value.name + "？",
    confirmButtonColor: "#DCBB89",
    cancelButtonColor: "#999999",
    width: "90%",
  })
    .then(() => {
      MyTeamApi._unbind({
        shop_clerk_uuid,
        shop_clerk_uuid_not_required: false,
      })
        .then((res) => {
          if (res?.code === 200) {
            showSuccessToast("解绑成功！");
            router.push("/myTeam");
          } else {
            showFailToast(res?.msg || res?.message || "解绑失败！");
          }
        })
        .catch((err) => {
          //   console.log(err);
          //   showFailToast(err?.msg || err?.message || "解绑失败！");
        });
    })
    .catch(() => {});
}
// 恢复在职
async function resetMember() {
  const valid = await formRef.value.validate();
  if (!valid) return;

  const res = MyTeamApi._editMember(formData).catch();
  if (res?.code === 200) {
    showSuccessToast("操作成功！");
    router.push("/myTeam");
  } else {
    showFailToast("操作失败！");
  }
}

// 提交表单
const onSubmit = async () => {
  await formRef.value.validate();

  let api = null;
  if (id) {
    api = MyTeamApi._editMember;
  } else {
    api = MyTeamApi._addMember;
  }

  const res = await api(formData.value).catch();
  if (res?.code === 200) {
    showSuccessToast("操作成功！");
    router.push("/myTeam");
  } else {
    showFailToast("操作失败！");
  }
};

// --------------------------------------- 请求
const GroupService = {
  async getDepartmentTree() {
    let res = await MyTeamApi._departmentTree({
      shop_clerk_uuid,
      shop_clerk_uuid_not_required: false,
    }).catch((err) => {});
    if (res?.code === 200) {
      //   departmentList.value = markTargetAsDisabled(res?.data || []);
      departmentList.value = res?.data || [];
    }
  },
  getPosition() {
    MyTeamApi._positionList({
      shop_clerk_uuid,
      shop_clerk_uuid_not_required: false,
    }).then(
      (res) => {
        positionList.value = (res?.data || [])?.map((v) => ({
          text: v.name,
          value: v.uuid,
        }));
      },
      (rej) => {
        console.log(rej);
      },
    );
  },

  getNameByPhone(phone) {
    return MyTeamApi._msgByPhone({ phone }).then(
      (res) => {
        return res;
      },
      (rej) => {
        console.log(rej);
        return rej;
      },
    );
  },
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    如果没有底部按钮, page-container添加 none_bottom_button 类名

    **** 在 @/scss/common.scss ****
*/

.pct50 {
  width: 50%;
}

.form-card {
  background: #fff;
  margin-top: 16px;
  padding: 0 16px;

  background: #ffffff;
  border-radius: 8px;
}

/* 必填星号样式 */
.required-mark {
  color: #ee0a24;
  margin-right: 4px;
}

/* 标签字体颜色 */
.van-cell__title {
  color: #323233;
  font-size: 15px;
}

/* 输入框占位符颜色 */
.van-field__placeholder {
  color: #c8c9cc;
}

:deep(.van-cell__title),
.left-label {
  height: 22px;
  font-family:
    PingFang SC,
    PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.desc-text {
  margin-right: 4px;
}

input,
:deep(input) {
  &:-internal-autofill-selected {
    background-color: transparent !important;
  }
}

.mr-10 {
  margin-right: 10px;
}
/* 布局样式优化 */
.cell-group-custom-header {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .cell-group-custom-title {
    line-height: 24px;

    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .cell-group-custom-desc {
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    text-align: left;
    font-style: normal;
    text-transform: none;

    margin-top: 4px;
    line-height: 18px;

    &.orange {
      color: #ff7123;
    }
  }

  .fieldBtnBox {
    width: 24px;
    height: 24px;
    margin-left: 5px;
  }
}

.sureBtn {
  width: 90%;
  margin: 0 auto;
  padding: 10px 0;
}

/* 内容区域的内边距，让展开后看起来不贴边 */
.cell-group-custom-content {
  padding-left: 16px;
  /* 如果需要背景色区分，可以取消下面注释 */
  /* background-color: #f7f8fa; */
}

/* 隐藏原生滚动条但保留功能 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  background: transparent;
}
</style>
